var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamonds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "5.75 1.75 20.5 28.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.97 1.75H7.03c-.7 0-1.28.57-1.28 1.28v25.94c0 .71.58 1.28 1.28 1.28h17.94c.7 0 1.28-.57 1.28-1.28V3.03c0-.71-.58-1.28-1.28-1.28zm-4.1 14.37-4.65 8.09c-.05.08-.13.13-.22.13s-.17-.05-.22-.13l-4.65-8.09a.255.255 0 0 1 0-.24l4.65-8.09c.09-.16.35-.16.44 0l4.65 8.09c.04.07.04.17 0 .24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamonds);
export default __webpack_public_path__ + "static/media/diamonds.2e79d58a43b49ca85d507cba0951f787.svg";
export { ForwardRef as ReactComponent };